import React from 'react';

import Badge from './Badge';
import { USER_ROLES } from '../../constants/roles';

// Sidebar profile-card role indicator (AppShell.jsx). Unlike
// components/admin/RoleBadge.jsx's title-case "Admin"/"User" table
// column, this always uppercases and displays the raw backend
// `user.role` value rather than mapping it through a fixed admin/user
// pair - so a future role (e.g. "owner", not in USER_ROLES yet) still
// renders correctly ("OWNER") instead of silently collapsing to "User".
function RoleTag({ role }) {
  if (!role) return null;

  return (
    <Badge variant={role === USER_ROLES.ADMIN ? 'question' : 'neutral'}>
      {role.toUpperCase()}
    </Badge>
  );
}

export default RoleTag;
